// Mock data for Bad Girl's Society Landing Page

export const heroData = {
  headline: "Social Media Content & Marketing Agentur für Creator",
  subheadline: "Wir entwickeln Content nicht nach Bauchgefühl, sondern mit Strategie, Daten und persönlicher Betreuung – für einen professionellen Social-Media-Auftritt und nachhaltiges Wachstum.",
  ctaPrimary: "Als Creator bewerben",
  ctaSecondary: "Kostenlos anfragen",
  trustElements: [
    "Persönliche Betreuung",
    "Individuelle Content-Strategie",
    "Datenbasierte Optimierung"
  ]
};

export const targetAudienceData = {
  sectionTitle: "Für wen ist Bad Girl's Society?",
  audiences: [
    {
      id: 1,
      type: "Creator, die professionell starten möchten",
      painPoints: [
        "Du möchtest Social Media professionell aufbauen, weißt aber nicht, wo du anfangen sollst?",
        "Dir fehlt eine klare Content-Strategie?",
        "Du brauchst Unterstützung bei Positionierung, Planung und Umsetzung?",
        "Du möchtest nicht einfach wahllos posten, sondern systematisch vorgehen?"
      ],
      result: "Wir schaffen gemeinsam die Struktur und Strategie für deinen professionellen Start."
    },
    {
      id: 2,
      type: "Bereits aktive Creator",
      painPoints: [
        "Du produzierst bereits Content, aber dein Wachstum bleibt hinter deinem Potenzial?",
        "Du weißt nicht genau, welche Inhalte wirklich funktionieren?",
        "Planung, Analyse und Content-Produktion werden zunehmend unübersichtlich?",
        "Du möchtest deinen Auftritt professioneller und strategischer aufbauen?"
      ],
      result: "Wir analysieren deinen Content, entwickeln deine Strategie weiter und optimieren kontinuierlich anhand deiner tatsächlichen Performance."
    }
  ]
};

export const servicesData = {
  sectionTitle: "Was wir bieten",
  services: [
    {
      id: 1,
      icon: "target",
      title: "Content-Strategie",
      description: "Individuelle Content-Konzepte passend zu Creator, Zielgruppe, Plattform und bisherigen Ergebnissen."
    },
    {
      id: 2,
      icon: "calendar",
      title: "Content-Planung",
      description: "Strukturierte Planung von Themen, Formaten, Hooks, Videos und Veröffentlichungen."
    },
    {
      id: 3,
      icon: "trendingUp",
      title: "Performance-Analyse",
      description: "Wir analysieren die tatsächliche Performance des Contents und nutzen die Ergebnisse für zukünftige Entscheidungen."
    },
    {
      id: 4,
      icon: "settings",
      title: "Social Media Management",
      description: "Struktur, Planung und Organisation der Social-Media-Aktivitäten – abgestimmt auf den jeweiligen Creator."
    },
    {
      id: 5,
      icon: "sparkles",
      title: "Positionierung & Personal Brand",
      description: "Entwicklung eines klaren, wiedererkennbaren Auftritts statt austauschbarem Content."
    },
    {
      id: 6,
      icon: "users",
      title: "Persönliche Betreuung",
      description: "Individuelle Zusammenarbeit und kontinuierliche Weiterentwicklung statt anonymer Standardlösungen."
    }
  ]
};

export const whyUsData = {
  sectionTitle: "Warum Bad Girl's Society?",
  differentiators: [
    {
      id: 1,
      title: "Individuell statt Standard",
      description: "Jeder Creator wird anhand seiner eigenen Marke, Zielgruppe und Daten betrachtet."
    },
    {
      id: 2,
      title: "Daten statt Bauchgefühl",
      description: "Entscheidungen werden nicht ausschließlich nach Trends getroffen. Performance-Daten fließen kontinuierlich in die weitere Strategie ein."
    },
    {
      id: 3,
      title: "Content mit System",
      description: "Von der Idee über Planung und Veröffentlichung bis zur Auswertung entsteht ein klarer Prozess."
    },
    {
      id: 4,
      title: "Persönliche Zusammenarbeit",
      description: "Creator erhalten persönliche Betreuung und einen festen Ansprechpartner."
    },
    {
      id: 5,
      title: "Langfristiger Markenaufbau",
      description: "Unser Ziel ist nicht ein einzelner erfolgreicher Post, sondern ein professioneller und langfristig entwickelter Social-Media-Auftritt."
    }
  ]
};

export const processData = {
  sectionTitle: "So arbeiten wir",
  steps: [
    {
      id: 1,
      number: "01",
      title: "Kennenlernen & Analyse",
      description: "Wir schauen uns Creator, Accounts, bisherigen Content, Ziele und Ausgangssituation an."
    },
    {
      id: 2,
      number: "02",
      title: "Strategie",
      description: "Auf Basis der vorhandenen Daten entwickeln wir eine individuelle Content- und Wachstumsstrategie."
    },
    {
      id: 3,
      number: "03",
      title: "Content-Planung",
      description: "Wir entwickeln konkrete Content-Ideen, Formate, Hooks und einen strukturierten Plan."
    },
    {
      id: 4,
      number: "04",
      title: "Umsetzung",
      description: "Der Content wird produziert und strukturiert veröffentlicht."
    },
    {
      id: 5,
      number: "05",
      title: "Analyse & Optimierung",
      description: "Wir prüfen regelmäßig die Ergebnisse und entwickeln zukünftigen Content anhand echter Performance-Daten weiter."
    }
  ]
};

export const benefitsData = {
  sectionTitle: "Deine Vorteile",
  benefits: [
    "Mehr Struktur und Klarheit in deinem Social Media Business",
    "Professioneller Auftritt statt Amateur-Niveau",
    "Bessere Nutzung deines vollen Potenzials",
    "Schnellere Fortschritte durch erprobte Systeme",
    "Persönlicher Support bei allen Fragen",
    "Langfristige Strategie für nachhaltiges Wachstum"
  ]
};

export const faqData = {
  sectionTitle: "Häufig gestellte Fragen",
  faqs: [
    {
      id: 1,
      question: "Was macht Bad Girl's Society?",
      answer: "Bad Girl's Society ist eine Content & Marketing Agentur für Creator und bietet zusätzlich TikTok LIVE Management an. Wir unterstützen Creator bei Content-Strategie, Content-Planung, Performance-Analyse und professionellem Wachstum."
    },
    {
      id: 2,
      question: "Für welche Creator ist die Betreuung geeignet?",
      answer: "Sowohl für Creator am Anfang als auch für bereits aktive Creator, die ihren Social-Media-Auftritt professioneller und strategischer entwickeln möchten. Wir arbeiten mit Creatorn zusammen, die Instagram, TikTok oder andere Plattformen nutzen."
    },
    {
      id: 3,
      question: "Was ist der Unterschied zwischen Content & Marketing und TikTok LIVE Management?",
      answer: "Content & Marketing fokussiert sich auf Content-Strategie, Planung und Performance-Optimierung für Social-Media-Posts. TikTok LIVE Management unterstützt speziell Creator, die TikTok LIVE professionell nutzen möchten – mit LIVE-Strategie, Onboarding und kontinuierlicher Betreuung."
    },
    {
      id: 4,
      question: "Garantiert BGS bestimmte Reichweiten oder Followerzahlen?",
      answer: "Nein. Social-Media-Performance lässt sich nicht garantieren. Wir arbeiten strategisch, datenbasiert und optimieren kontinuierlich. Unser Ziel ist langfristiger, professioneller Aufbau – keine kurzfristigen Versprechen."
    },
    {
      id: 5,
      question: "Was sind die Voraussetzungen für eine Bewerbung?",
      answer: "Du solltest mindestens 18 Jahre alt sein und Interesse an professionellem Content-Aufbau oder TikTok LIVE haben. Für Content & Marketing ist ein Instagram-Account relevant, für TikTok LIVE ein TikTok-Account. Erfahrung ist nicht zwingend erforderlich."
    },
    {
      id: 6,
      question: "Entstehen Kosten für die Betreuung?",
      answer: "Die Details zur Zusammenarbeit besprechen wir individuell im Erstgespräch. Es gibt keine Pauschalangebote, da jede Creator-Situation unterschiedlich ist. Wir legen Wert auf transparente und faire Konditionen."
    },
    {
      id: 7,
      question: "Wie läuft die Bewerbung ab?",
      answer: "Du füllst das Bewerbungsformular aus und wählst deinen gewünschten Bereich (Content & Marketing oder TikTok LIVE). Wir melden uns zeitnah für ein erstes Gespräch und schauen gemeinsam, wie wir dich unterstützen können."
    },
    {
      id: 8,
      question: "Wie persönlich ist die Betreuung?",
      answer: "Sehr persönlich. Jeder Creator hat einen festen Ansprechpartner und erhält individuelle Beratung – keine anonyme Massen-Betreuung. Wir entwickeln gemeinsam deine Strategie und begleiten dich kontinuierlich."
    },
    {
      id: 9,
      question: "Kann ich mich nur für TikTok LIVE bewerben?",
      answer: "Ja. Interessenten können im Bewerbungsformular auswählen, für welchen Bereich sie sich interessieren: Content & Marketing oder TikTok LIVE Management."
    },
    {
      id: 10,
      question: "Wo befindet sich Bad Girl's Society?",
      answer: "Bad Girl's Society, oft auch ohne Apostroph als Bad Girl Society oder kurz BGS geschrieben, hat ihren Sitz in Köln-Kalk. Das Büro in der Auf d. Driesch 19, 51107 Köln, ist montags bis mittwochs von 10 bis 20 Uhr und donnerstags bis freitags von 10 bis 18 Uhr erreichbar."
    }
  ]
};

export const tiktokLiveData = {
  sectionTitle: "TikTok LIVE Management",
  subtitle: "Neben unserer Content & Marketing Agentur betreut Bad Girl's Society auch TikTok LIVE Creator.",
  description: "Wir unterstützen LIVE Creator bei der professionellen Entwicklung und Optimierung ihrer TikTok LIVE-Aktivitäten.",
  services: [
    {
      id: 1,
      icon: "userCheck",
      title: "Persönliche LIVE-Betreuung",
      description: "Fester Ansprechpartner für Fragen rund um TikTok LIVE."
    },
    {
      id: 2,
      icon: "playCircle",
      title: "Onboarding",
      description: "Unterstützung beim professionellen Einstieg in den LIVE-Bereich."
    },
    {
      id: 3,
      icon: "target",
      title: "LIVE-Strategie",
      description: "Gemeinsame Weiterentwicklung von Streams, Formaten und Routinen."
    },
    {
      id: 4,
      icon: "barChart",
      title: "Performance & Analyse",
      description: "Auswertung der LIVE-Aktivitäten und Performance zur kontinuierlichen Verbesserung."
    },
    {
      id: 5,
      icon: "settings",
      title: "Technischer & organisatorischer Support",
      description: "Unterstützung bei Fragen und Problemen rund um den LIVE-Bereich."
    },
    {
      id: 6,
      icon: "trendingUp",
      title: "Langfristige Betreuung",
      description: "Wir begleiten Creator nicht nur beim Einstieg, sondern bei ihrer weiteren Entwicklung als LIVE Creator."
    }
  ],
  cta: "Als TikTok LIVE Creator bewerben"
};

export const mockFormSubmit = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock form submission:", formData);
      resolve({
        success: true,
        message: "Bewerbung erfolgreich gesendet!"
      });
    }, 1000);
  });
};
